module.exports = __webpack_public_path__ + "assets/facebook.c36cc80e.svg";